import React, { useEffect, useState, useCallback, useMemo } from "react";
import produce from "immer";
import {
  Button,
  Checkbox,
  DatePicker,
  FlexboxGrid,
  Input,
  IconButton,
  Modal,
  SelectPicker,
  Table,
  CheckPicker,
  CheckTreePicker,
  Tag,
} from 'rsuite';
import { InputDataRange } from '~/components/InputDataRange';
import { Attachment } from '@rsuite/icons';
import { toast } from 'react-toastify';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import pt from 'date-fns/locale/pt-BR';
import { useDebouncedCallback } from 'use-debounce/lib';
import { Container } from '~/styles/tabela1';
import api from '~/services/api';
import CelulaAcao from '~/components/Celulas/components/CelulaAcao';
import { FiltroExperiencias } from '~/components/FiltroExperiencias';
import { FiltroTreinamentos } from '~/components/FiltroTreinamentos';
import SearchInputTable from '~/components/SearchInputTable';
import SelectState from '~/components/SelectState';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import { GerarCSV as CSV } from '~/utils/gerarCSV';
import { ImBlocked } from "react-icons/im";
import { BsFillGeoAltFill } from 'react-icons/bs';
import { IoBagRemoveSharp, IoBagSharp } from "react-icons/io5";
import EditarProfissional from '../EditarProfissional';
import SmartLiberacao from '../components/SmartLiberacao';
import AdvancedFilters from '../../../components/AdvancedFilters';
import PageHeader from '../../../components/PageHeader';
import MetricsCards from '../../../components/MetricCards';
import { InterestCell, LocationCell, ProfissionalCell } from '../components/TableCells';


const { HeaderCell, Column, Cell } = Table;

function ListaProfissionalBloqueado() {
  const [profissionais, setProfissionais] = useState({
    lista: [],
    quantidade: 0,
  });
  const [experiencias, setExperiencias] = useState([]);
  const [experienciaSelecionada, setExperienciaSelecionada] = useState();
  const [treinamentos, setTreinamentos] = useState([]);
  const [treinamentoSelecionado, setTreinamentoSelecionado] = useState();
  const [interesses, setInteresses] = useState([]);
  const [interesseSelecionado, setInteresseSelecionado] = useState([]);
  const [perfilSelecionado, setPerfilSelecionado] = useState(false);
  const [estadoSelecionado, setEstadoSelecionado] = useState();
  const [ufSelecionado, setUfSelecionado] = useState();
  const [cidade, setCidade] = useState("");
  const [cidadeInput, setCidadeInput] = useState("");
  const [bairro, setBairro] = useState("");
  const [bairroInput, setBairroInput] = useState("");
  const [analiseSelecionada, setAnaliseSelecionada] = useState();
  const [carregando, setCarregando] = useState(true);
  const [textodigitado, setTextoDigitado] = useState();
  const [pagina, setPagina] = useState(1);
  const [atributoSelecionado, setAtributoSelecioando] = useState("nome");
  const [profissionalEditando, setProfissionalEditando] = useState();
  const [showEditarProfissional, setShowEditarProfissional] = useState(false);
  const [selecionarCertificado, setSelecionarCertificado] = useState(false);
  const [modalConfirmacao, setModalConfirmacao] = useState(false);
  const [dataSelecionada, setDataSelecionada] = useState();
  const [buscarCSV, setBuscarCSV] = useState(false);
  const atributosFiltro = [
    {
      label: "Nome",
      value: "nome",
    },
    {
      label: "Email",
      value: "email",
    },
    {
      label: "Cpf",
      value: "cpf_cnpj",
    },
  ];

  const [orderBy, setOrderBy] = useState("order by Tempo de Cadastro desc");

  const locale = {
    sunday: "Dom",
    monday: "Seg",
    tuesday: "Ter",
    wednesday: "Qua",
    thursday: "Qui",
    friday: "Sex",
    saturday: "Sab",
    ok: "Ok",
    today: "Hoje",
    yesterday: "Ontem",
    hours: "Horas",
    minutes: "Minutos",
    seconds: "Segundos",
  };

  const { callback: debouncedSetCidade } = useDebouncedCallback(
    (value) => setCidade(value),
    500
  );
  const { callback: debouncedSetBairro } = useDebouncedCallback(
    (value) => setBairro(value),
    500
  );

  function getInteresse(status) {
    const map = {
      freelancer: "Freelancer",
      emprego: "Emprego",
      emprego_freelancer: "Emprego e Freelancer",
    };

    return map[status];
  }

  const buscarProfissionais = useCallback(async () => {
    setModalConfirmacao(false);
    setCarregando(true);
    try {
      const resposta = await api.get("profissionais/bloqueados", {
        params: {
          [atributoSelecionado]: textodigitado,
          pagina,
          estado: estadoSelecionado,
          treinamentos: treinamentoSelecionado,
          certificado: selecionarCertificado,
          interesses: interesseSelecionado,
          perfil: perfilSelecionado,
          analise: analiseSelecionada,
          experiencias: experienciaSelecionada,
          cidade,
          bairro,
          orderBy,
          data: dataSelecionada,
          csv: buscarCSV,
        },
      });

      const lista = resposta.data.lista.map((profissional) => ({
        // ...profissional,
        ...(buscarCSV === false && profissional),
        Nome: profissional.nome,
        Email: profissional.email,
        Telefone: profissional.telefone1,
        "Cpf/Cnpj": profissional.cpf_cnpj,
        "Tempo de Cadastro": formatDistanceToNow(
          new Date(profissional.data_criacao),
          {
            locale: pt,
          }
        ),
        Cidade: profissional.endereco.bairro.cidade.cidade,
        Estado: profissional.endereco.bairro.cidade.estado.estado,
        Bairro: profissional.endereco.bairro.bairro,
        Interesse: getInteresse(profissional.interesses),
      }));
      if (buscarCSV) {
        CSV({
          data: lista,
          download: true,
        });

        setCarregando(false);
        toast.success(`Foram exportados ${lista.length} registros.`);
        setBuscarCSV(false);
        return;
      }

      setProfissionais({
        lista,
        quantidade: lista.length > 0 ? lista[0].full_count : 0,
      });
      if (profissionais.quantidade === 0) setPagina(1);
    } catch (e) {
      if (buscarCSV) {
        setCarregando(false);
        toast.error("Erro ao Exportar os dados");
        setBuscarCSV(false);
        return;
      }
      toast.error(e.message);
    }
    setCarregando(false);
  }, [
    pagina,
    atributoSelecionado,
    textodigitado,
    analiseSelecionada,
    estadoSelecionado,
    treinamentoSelecionado,
    experienciaSelecionada,
    selecionarCertificado,
    cidade,
    bairro,
    orderBy,
    dataSelecionada,
    interesseSelecionado,
    perfilSelecionado,
    buscarCSV,
    setPagina,
    profissionais.quantidade,
  ]);

  useEffect(() => {
    buscarProfissionais();
  }, [buscarProfissionais]);

  useEffect(() => {
    const buscarFiltros = async () => {
      const [experienciasLista, treinamentosLista] = await Promise.all([
        api.get("profissao"),
        api.get("treinamento"),
      ]);

      const newLista = experienciasLista.data.map((map) => ({
        label: map.profissao,
        value: map.id,
      }));

      setTreinamentos(treinamentosLista.data);
      setExperiencias(newLista);
      setExperiencias([
        {
          label: "Experiencias",
          value: "Todos",
          children: [...newLista],
        },
      ]);
    };

    buscarFiltros();
  }, []);

  function abrirEditarProfissional(profissional) {
    setProfissionalEditando(profissional);
    setShowEditarProfissional(true);
  }

  const activeFilters = useMemo(() => {
    const filters = [];

    if (cidade) {
      filters.push({
        key: "cidade",
        label: `Cidade: ${cidade}`,
        clear: () => {
          setCidade("");
          setCidadeInput("");
        },
      });
    }

    if (bairro) {
      filters.push({
        key: "bairro",
        label: `Bairro: ${bairro}`,
        clear: () => {
          setBairro("");
          setBairroInput("");
        },
      });
    }

    if (estadoSelecionado) {
      filters.push({
        key: "estado",
        label: `Estado: ${ufSelecionado || estadoSelecionado}`,
        clear: () => {
          setEstadoSelecionado(undefined);
          setUfSelecionado(undefined);
        },
      });
    }

    if (treinamentoSelecionado?.length) {
      filters.push({
        key: "treinamento",
        label: `${treinamentoSelecionado.length} treinamento(s)`,
        clear: () => setTreinamentoSelecionado([]),
      });
    }

    if (experienciaSelecionada?.length) {
      filters.push({
        key: "experiencia",
        label: `${experienciaSelecionada.length} experiência(s)`,
        clear: () => setExperienciaSelecionada([]),
      });
    }

    if (interesseSelecionado?.length) {
      filters.push({
        key: "interesse",
        label: `${interesseSelecionado.length} interesse(s)`,
        clear: () => setInteresseSelecionado([]),
      });
    }

    if (analiseSelecionada) {
      const texto =
        analiseSelecionada === "analisado"
          ? "Perfil Analisado"
          : analiseSelecionada === "nao_analisado"
          ? "Perfil Não Analisado"
          : "Todos";
      filters.push({
        key: "analise",
        label: texto,
        clear: () => setAnaliseSelecionada(undefined),
      });
    }

    if (perfilSelecionado) {
      filters.push({
        key: "perfil",
        label: "Perfil Bom",
        clear: () => setPerfilSelecionado(false),
      });
    }

    if (selecionarCertificado) {
      filters.push({
        key: "certificado",
        label: "Enviou Certificado",
        clear: () => setSelecionarCertificado(false),
      });
    }

    if (dataSelecionada?.length === 2) {
      filters.push({
        key: "data",
        label: "Data de Cadastro",
        clear: () => setDataSelecionada(undefined),
      });
    }

    return filters;
  }, [
    cidade,
    bairro,
    estadoSelecionado,
    treinamentoSelecionado,
    experienciaSelecionada,
    interesseSelecionado,
    analiseSelecionada,
    perfilSelecionado,
    selecionarCertificado,
    dataSelecionada,
  ]);

  return (
    <Container>
      <PageHeader
        title="Profissionais Bloqueados"
        // subtitle="Gerencie profissionais bloqueados e realize liberações rapidamente."
        actions={
          <>
            <SmartLiberacao onConcluido={buscarProfissionais} />

            <Button
              appearance="ghost"
              startIcon={<Attachment />}
              onClick={() => setModalConfirmacao(true)}
            >
              Exportar CSV
            </Button>
          </>
        }
      />
      <MetricsCards
        items={[
          {
            title: "Total Bloqueados",
            value: profissionais.quantidade,
            icon: <ImBlocked size="30px" />,
            background: "#FADBD8",
            color: "#D32F2F",
          },
          {
            title: 'Cidade com mais Profissionais Bloqueados',
            value: '-',
            icon: <BsFillGeoAltFill size="30px" />,
            background: '#ECFDF3',
            color: '#16A34A'
          },
          {
            title: 'Interessados em Freelancer',
            value: '-',
            icon: <IoBagRemoveSharp size="30px" />,
            background: '#F3E8FF',
            color: '#7C3AED'
          },
          {
            title: 'Interessados em Emprego',
            value: '-',
            icon: <IoBagSharp size='30px' />,
            background: '#EFF6FF',
            color: '#2563EB'
          },
        ]}
      />
      <AdvancedFilters
        activeFilters={activeFilters}
        header={
          <>
            <SearchInputTable
              place="Buscar profissional..."
              setTextoDigitado={setTextoDigitado}
              estilo={{ width: "700px" }}
            />
            <SelectPicker
              appearance="default"
              style={{ marginLeft: "-5px" }}
              searchable={false}
              data={atributosFiltro}
              value={atributoSelecionado}
              cleanable={false}
              onChange={(value) => setAtributoSelecioando(value)}
            />
          </>
        }
      >
        <Input
          style={{ width: "250px" }}
          value={cidadeInput}
          placeholder="Cidade"
          onChange={(value) => {
            setCidadeInput(value);
            debouncedSetCidade(value);
          }}
        />
        <Input
          style={{ width: "250px" }}
          value={bairroInput}
          placeholder="Bairro"
          onChange={(value) => {
            setBairroInput(value);
            debouncedSetBairro(value);
          }}
        />
        <SelectState
          selectedState={estadoSelecionado}
          setUfSelecionado={setUfSelecionado}
          setSelectedStates={setEstadoSelecionado}
          // marginRight
        />
        <FiltroTreinamentos
          appearance="default"
          style={{ width: 224 }}
          searchable={false}
          data={treinamentos.map((treinamento) => ({
            label: treinamento.treinamento,
            value: treinamento.id,
          }))}
          value={treinamentoSelecionado}
          onChange={(value) => setTreinamentoSelecionado(value)}
        />
        <CheckTreePicker
          style={{ width: 224 }}
          defaultExpandAll
          placeholder="Experiencias"
          appearance="default"
          data={experiencias}
          value={experienciaSelecionada}
          onChange={(value) => setExperienciaSelecionada(value)}
        />
        <InputDataRange
          ranges={[]}
          placeholder="Data de Cadastro"
          isoWeek
          value={dataSelecionada}
          locale={locale}
          onChange={setDataSelecionada}
        />
        <CheckPicker
          appearance="default"
          style={{ marginRight: "15px" }}
          searchable={false}
          placeholder="Interesse"
          // data={{ label:"freelancer"}}
          data={[
            {
              label: "Freelancer",
              value: "freelancer",
            },
            {
              label: "Emprego",
              value: "emprego",
            },
            {
              label: "Emprego e Freelancer",
              value: "emprego_freelancer",
            },
          ]}
          value={interesseSelecionado}
          onChange={(value) => setInteresseSelecionado(value)}
        />
        <SelectPicker
          appearance="default"
          style={{ marginLeft: "-15px", width: 150 }}
          searchable={false}
          placeholder="Perfil"
          data={[
            {
              label: "Perfil Analisado",
              value: "analisado",
            },
            {
              label: "Perfil Não Analisado",
              value: "nao_analisado",
            },
            {
              label: "Todos",
              value: "todos",
            },
          ]}
          value={analiseSelecionada}
          cleanable={false}
          onChange={(value) => setAnaliseSelecionada(value)}
        />
        <Checkbox
          style={{ marginLeft: "-10px", marginRight: "10px" }}
          checked={perfilSelecionado}
          onChange={(bool, value) => setPerfilSelecionado(value)}
        >
          Perfil Bom
        </Checkbox>
        <Checkbox
          value={selecionarCertificado}
          onChange={(a, valor) => {
            setSelecionarCertificado(valor);
          }}
        >
          Enviou Certificado
        </Checkbox>
      </AdvancedFilters>
      <FlexboxGrid style={{ width: "100%" }}>
        <TablePagination
          carregando={carregando}
          dados={profissionais.lista}
          quantidade={profissionais.quantidade}
          onChangePage={setPagina}
          setOrderBy={setOrderBy}
          wordWrap="break-word"
        >
          <Column align="center" width={100}>
            <HeaderCell>
              <TableHeaderTooltip label="Ação" tooltip="Ação" />
            </HeaderCell>
            <CelulaAcao
              dataKey="id"
              onEditar={(profissional) => {
                abrirEditarProfissional(profissional);
              }}
            />
          </Column>
          <Column width={320}>
            <HeaderCell>
              <TableHeaderTooltip label="Profissional" tooltip="Profissional" />
            </HeaderCell>

            <Cell>{(rowData) => <ProfissionalCell rowData={rowData} />}</Cell>
          </Column>
          <Column width={180}>
            <HeaderCell>
              <TableHeaderTooltip label="Localização" tooltip="Localização" />
            </HeaderCell>

            <Cell>{(rowData) => <LocationCell rowData={rowData} />}</Cell>
          </Column>

          <Column resizable width={170} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Cadastro" tooltip="Cadastro" />
            </HeaderCell>
            <Cell dataKey="Tempo de Cadastro" />
          </Column>
          <Column width={160}>
            <HeaderCell>
              <TableHeaderTooltip
                label="Análise IA"
                tooltip="Análise do documento"
              />
            </HeaderCell>
            <Cell>
              {(rowData) => {
                const status = rowData.analise_documento_status;
                const config = {
                  approved: { texto: "IA: aprovar", cor: "green" },
                  not_approved: { texto: "IA: não aprovar", cor: "red" },
                  processing: { texto: "Processando", cor: "blue" },
                  pending: { texto: "Pendente", cor: "orange" },
                  error: { texto: "Erro", cor: "red" },
                }[status] || { texto: "Sem análise", cor: "default" };

                return <Tag color={config.cor}>{config.texto}</Tag>;
              }}
            </Cell>
          </Column>
          <Column width={180}>
            <HeaderCell>
              <TableHeaderTooltip label="Interesse" tooltip="Interesse" />
            </HeaderCell>

            <Cell>{(rowData) => <InterestCell rowData={rowData} />}</Cell>
          </Column>
        </TablePagination>
      </FlexboxGrid>
      <EditarProfissional
        idProfissional={profissionalEditando && profissionalEditando.id}
        showEditarProfissional={showEditarProfissional}
        setShowEditarProfissional={setShowEditarProfissional}
        atualizarLista={buscarProfissionais}
      />
      <Modal
        open={modalConfirmacao}
        onClose={() => setModalConfirmacao(false)}
        size="xs"
      >
        <Modal.Header>Gerar Relatório CSV</Modal.Header>
        <Modal.Body>
          <p>
            Deseja realmente gerar o csv dos profissionais com o filtro atual?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setModalConfirmacao(false)}
            appearance="subtle"
          >
            Cancelar
          </Button>
          <Button
            appearance="primary"
            type="button"
            onClick={() => {
              setBuscarCSV(true);
              buscarProfissionais();
            }}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default ListaProfissionalBloqueado;
